import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const checkoutUrl = 'https://www.yennilemon.com/cart/44211058212999:1';
  return <AnimatePresence data-id="element-224">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 z-50 bg-sage shadow-md py-3 px-4 md:px-8" data-id="element-225">
          <div className="max-w-6xl mx-auto flex flex-row items-center justify-between" data-id="element-226">
            <div className="hidden md:flex flex-col text-white" data-id="element-227">
              <span className="font-heading font-semibold text-lg" data-id="element-228">
                Plan Antiinflamatorio +40
              </span>
              <span className="text-xs opacity-90" data-id="element-229">
                Oferta de lanzamiento termina pronto
              </span>
            </div>

            <div className="flex items-center justify-between w-full md:w-auto gap-4 md:gap-6" data-id="element-230">
              <div className="flex flex-col items-end text-white" data-id="element-231">
                <div className="flex items-center gap-2" data-id="element-232">
                  <span className="text-xs line-through opacity-70" data-id="element-233">
                    $19.99 USD
                  </span>
                  <span className="bg-warm-accent text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-234">
                    -50%
                  </span>
                </div>
                <span className="font-bold text-lg leading-none" data-id="element-235">
                  $6.36 USD
                </span>
              </div>

              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} className="bg-white text-sage font-bold py-2 px-6 rounded-full text-sm md:text-base hover:bg-cream transition-colors shadow-sm whitespace-nowrap" data-id="element-236">
                Quiero empezar hoy
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}